import Card2 from "./Card2";
import styled from "styled-components";
import Record2 from "./Record2";
import { useRef } from "react";
export default function Panel2() {
  const r1 = useRef()
  return (
    <Wrapper>
      <Card2 onChange={() => {
        r1.current.loadData()
      }}/>
      <Record2 ref={r1}/>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  padding: .8rem 1.0rem .5rem;
`;
